import _ from 'lodash';
export const checkCustomInfomation = (customsInformationItems) => {
  const data = _.cloneDeep(customsInformationItems || []);
  let flag = false;
  data.forEach((i) => {
    const {
      title,
      quantity,
      unitPrice,
      regionOfOrigin, //hsCode
    } = i || {};
    if (!title) {
      i.titleError = true;
      flag = true;
    }
    if (!quantity) {
      i.quantityError = true;
      flag = true;
    }
    if (!unitPrice) {
      i.unitPriceError = true;
      flag = true;
    }
    if (!regionOfOrigin) {
      i.regionOfOriginError = true;
      flag = true;
    }
    // if (!hsCode || !(hsCode || {}).uuid) {
    //   i.hsCodeError = true;
    //   flag = true;
    // }
  });
  return { flag, data };
};
